const productsShowcase = (() => {
  const EL_SECTION = '[data-products-showcase]';
  const EL_TAB = '[data-products-showcase-tab]';
  const EL_CONTENT = '[data-content]';

  function createLayout(elSection) {
    const elContents = elSection.querySelectorAll(EL_CONTENT);
    const elTabs = elSection.querySelectorAll(EL_TAB);

    let isMobile = window.matchMedia('(max-width: 1023px)').matches;
    let elActiveTab = [...elTabs].find(el => el.classList.contains('active'));
    let { productsShowcaseTab: activeId } = elActiveTab.dataset;

    elContents.forEach(el => {
      const { content: id } = el.dataset;
      el.ariaHidden = isMobile ? id !== activeId : false;
    })
  }

  function setActiveTab(ev) {
    ev.preventDefault();
    const elTab = ev.currentTarget;
    const elSection = elTab.closest(EL_SECTION);
    const elTabs = elSection.querySelectorAll(EL_TAB);
    const elContents = elSection.querySelectorAll(EL_CONTENT);

    let { productsShowcaseTab: activeId } = elTab.dataset;
    
    window.scrollTo({ top: 140, behavior: 'smooth' });

    elTabs.forEach(el => {
      el.classList.toggle('active', el == elTab);
    })

    elContents.forEach(el => {
      const { content: id } = el.dataset;
      el.ariaHidden = id !== activeId;
    })
  }

  function init() {
    const elSections = document.querySelectorAll(EL_SECTION);
    elSections.forEach(el => {
      createLayout(el);
      window.addEventListener('resize', () => createLayout(el));
    });

    const elTabs = document.querySelectorAll(EL_TAB);
    elTabs.forEach(el => {
      el.removeEventListener('click', setActiveTab);
      el.addEventListener('click', setActiveTab);
    })
  }

  return {
    init
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  productsShowcase.init();
})